// Which cards the new-hire welcome page shows. Kept out of the component so
// the decision can be tested on its own (welcomeSteps.test.js).
//
// CORRECTED 2026-10-31. "Signed" was offer_letter_signed_at AND
// handbook_acknowledged_at. Nothing has written the second since 2026-09-14 —
// the handbook is acknowledged on /my/policies, as its own record — so Step 1
// showed forever and the next step never appeared (Tinayja Summers). Two facts,
// two readings:
//   * the offer letter is signed when offer_letter_signed_at is set;
//   * a policy is owed when the profile's acknowledgments say published and
//     not acknowledged — read from acknowledgment_records by the server.
// The policies never hold up the offer or clearance (MyOfferLetterPage says so
// to the person); they are listed as their own card.

export function offerSigned(profile) {
  return !!profile.offer_letter_signed_at;
}

export function welcomeSteps(profile) {
  const signed = offerSigned(profile);
  const inClearance = ['pending_clearance', 'pending_hire'].includes(profile.status);
  return {
    offer: !signed,
    clearance: signed && inClearance,
    onboarding: profile.status === 'onboarding',
    clearanceWaitNote: signed && profile.status === 'pending_clearance',
    policies: (profile.acknowledgments || []).filter((a) => a.published && !a.acknowledged),
  };
}
